<template>
    <HeaderContent title="Program" />

    <TransportarionForm
        v-if="modalTransportation"
        :modal="modalTransportation"
        :selectedData="selectedTransportation"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalTransportation"
        @addOrUpdate="addOrUpdateTransportation"
    ></TransportarionForm>

    <AccommodationForm
        v-if="modalAccomodation"
        :modal="modalAccomodation"
        :selectedData="selectedAccomodation"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalAccomodation"
        @addOrUpdate="addOrUpdateAccomodation"
    ></AccommodationForm>

    <ActivityForm
        v-if="modalActivity"
        :modal="modalActivity"
        :selectedData="selectedActivity"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalActivity"
        @addOrUpdate="addOrUpdateActivity"
    ></ActivityForm>

    <MealForm
        v-if="modalMeal"
        :modal="modalMeal"
        :selectedData="selectedMeal"
        :defaultPax="formProgram.pax"
        @update:modal="updateModalMeal"
        @addOrUpdate="addOrUpdateMeal"
    ></MealForm>

    <BModal
        v-model="modalPreview"
        title="Preview Program"
        size="xl"
        hide-footer
    >
        <BRow class="mb-4">
            <BCol class="text-start">
                <span class="fw-bold">Program Name</span>
                <p>{{ formProgram?.name ?? "-" }}</p>
            </BCol>
            <BCol class="text-start">
                <span class="fw-bold">Pax</span>
                <p>{{ formProgram.pax ?? "-" }}</p>
            </BCol>
            <BCol class="text-start">
                <span class="fw-bold">From</span>
                <p>
                    {{
                        formProgram?.from_destination
                            ? formProgram?.from_destination?.name +
                              " (" +
                              formProgram?.from_destination?.code +
                              ")"
                            : "-"
                    }}
                </p>
            </BCol>
            <BCol class="text-start">
                <span class="fw-bold">To</span>
                <p>
                    {{
                        formProgram?.to_destination
                            ? formProgram?.to_destination?.name +
                              " (" +
                              formProgram?.to_destination?.code +
                              ")"
                            : "-"
                    }}
                </p>
            </BCol>
        </BRow>

        <div class="mb-4 pb-4">
            <!-- Transportation -->
            <div class="mb-3">
                <span class="fw-bold small text-muted text-uppercase">1. Transportation</span>
                <div class="table-responsive mt-1">
                    <table class="table table-sm table-bordered">
                        <thead class="table-secondary small">
                            <tr>
                                <th width="1" class="text-left">No</th>
                                <th class="text-left">Vehicle Name</th>
                                <th class="text-left">Vehicle Type</th>
                                <th class="text-center">Pax</th>
                                <th class="text-right" width="150">Price</th>
                                <th class="text-right" width="150">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody class="small">
                            <tr v-for="(item, index) in transportationItems" :key="'t-'+index">
                                <td class="text-left">{{ index + 1 }}</td>
                                <td class="text-left">{{ item.vehicle?.name }}</td>
                                <td class="text-left">{{ item.vehicle?.type }}</td>
                                <td class="text-center">{{ item.pax }}</td>
                                <td class="text-right">{{ formatRupiah(item.price) }}</td>
                                <td class="text-right">{{ formatRupiah(item.sub_total) }}</td>
                            </tr>
                            <tr v-if="!transportationItems.length">
                                <td class="text-center" colspan="6">No transportation available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Accomodation -->
            <div class="mb-3">
                <span class="fw-bold small text-muted text-uppercase">2. Accomodation</span>
                <div class="table-responsive mt-1">
                    <table class="table table-sm table-bordered">
                        <thead class="table-secondary small">
                            <tr>
                                <th width="1" class="text-left">No</th>
                                <th class="text-left">Hotel</th>
                                <th class="text-center">Pax</th>
                                <th class="text-right">Price</th>
                                <th class="text-right">Subtotal</th>
                                <th class="text-center">Extra Bed</th>
                                <th class="text-right">Extra Bed Price</th>
                                <th class="text-right">Total Price</th>
                            </tr>
                        </thead>
                        <tbody class="small">
                            <tr v-for="(item, index) in accomodationItems" :key="'ac-'+index">
                                <td class="text-left">{{ index + 1 }}</td>
                                <td class="text-left">
                                    <div class="fw-bold">{{ item.name }}</div>
                                    <div class="text-muted small">
                                        {{ item.destination?.name }}{{ item.room_type ? ' - ' + item.room_type : '' }}
                                    </div>
                                </td>
                                <td class="text-center">{{ item.pax }}</td>
                                <td class="text-right">{{ formatRupiah(item.price) }}</td>
                                <td class="text-right">{{ formatRupiah(item.sub_total) }}</td>
                                <td class="text-center">
                                    <span 
                                        class="badge" 
                                        :class="item.extra_bed == 1 ? 'border border-success text-success' : 'border border-danger text-danger'"
                                        style="padding: 2px 10px; border-radius: 4px;"
                                    >
                                        {{ item.extra_bed == 1 ? 'Yes' : 'No' }}
                                    </span>
                                </td>
                                <td class="text-right">{{ formatRupiah(item.extra_bed_price) }}</td>
                                <td class="text-right fw-bold">{{ formatRupiah(item.total_price) }}</td>
                            </tr>
                            <tr v-if="!accomodationItems.length">
                                <td class="text-center" colspan="8">No accomodation available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Activity -->
            <div class="mb-3">
                <span class="fw-bold small text-muted text-uppercase">3. Activity</span>
                <div class="table-responsive mt-1">
                    <table class="table table-sm table-bordered">
                        <thead class="table-secondary small">
                            <tr>
                                <th width="1" class="text-left">No</th>
                                <th class="text-left">Destination</th>
                                <th class="text-left">Activity Name</th>
                                <th class="text-center">Pax</th>
                                <th class="text-right" width="120">Price</th>
                                <th class="text-right" width="150">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody class="small">
                            <tr v-for="(item, index) in activityItems" :key="'act-'+index">
                                <td class="text-left">{{ index + 1 }}</td>
                                <td class="text-left">
                                    {{ item.destination?.name }} ({{ item.destination?.code }})
                                </td>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-center">{{ item.pax }}</td>
                                <td class="text-right">{{ formatRupiah(item.price) }}</td>
                                <td class="text-right">{{ formatRupiah(item.sub_total) }}</td>
                            </tr>
                            <tr v-if="!activityItems.length">
                                <td class="text-center" colspan="6">No activity available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Meals -->
            <div class="mb-3">
                <span class="fw-bold small text-muted text-uppercase">4. Meals</span>
                <div class="table-responsive mt-1">
                    <table class="table table-sm table-bordered">
                        <thead class="table-secondary small">
                            <tr>
                                <th width="1" class="text-left">No</th>
                                <th class="text-left">Meal Name</th>
                                <th class="text-center" width="80">Pax</th>
                                <th class="text-right" width="150">Price</th>
                                <th class="text-right" width="150">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody class="small">
                            <tr v-for="(item, index) in mealItems" :key="'m-'+index">
                                <td class="text-left">{{ index + 1 }}</td>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-center">{{ item.pax }}</td>
                                <td class="text-right">{{ formatRupiah(item.price) }}</td>
                                <td class="text-right">{{ formatRupiah(item.sub_total) }}</td>
                            </tr>
                            <tr v-if="!mealItems.length">
                                <td class="text-center" colspan="5">No meal available</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <BRow>
            <BCol>
                <div class="table-responsive">
                    <table class="table table-sm">
                        <tbody>
                            <tr style="font-size: 17px">
                                <td class="text-end fw-bold" colspan="2">Total Price ({{ formProgram?.pax }} Pax)</td>
                                <td class="text-end fw-bold bg-success text-white col-sm-2">
                                    {{ formProgram?.sub_total ? formatRupiah(formProgram.sub_total) : "Rp 0" }}
                                </td>
                            </tr>
                            <tr style="font-size: 15px">
                                <td class="text-end fw-bold" colspan="2">Price Per Person</td>
                                <td class="text-end fw-bold col-sm-2 text-muted">
                                    {{ formProgram?.price ? formatRupiah(formProgram.price) : "Rp 0" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </BCol>
        </BRow>

        <BRow class="mb-4 text-left">
            <BCol class="text-start">
                <span class="fw-bold">Inclusion</span>
                <ul v-if="formProgram.inclusion">
                    <li v-for="(item, index) in formProgram.inclusion.split('\n')" :key="index">
                        {{ item }}
                    </li>
                </ul>
                <p v-else>-</p>
            </BCol>
        </BRow>

        <BRow class="mb-4 text-left">
            <BCol class="text-start">
                <span class="fw-bold">Exclusion</span>
                <ul v-if="formProgram.exclusion">
                    <li v-for="(item, index) in formProgram.exclusion.split('\n')" :key="index">
                        {{ item }}
                    </li>
                </ul>
                <p v-else>-</p>
            </BCol>
        </BRow>

        <template #footer>
            <div class="d-flex justify-content-end mt-4">
                <BButton variant="secondary" @click="modalPreview = false" class="me-2">Close</BButton>
                <BButton @click="handleAction" variant="primary">Confirm & Save</BButton>
            </div>
        </template>
    </BModal>

    <BForm @submit.stop.prevent>
        <!-- 1. Basic Information -->
        <BCard class="mb-4 shadow-sm border-0">
            <template #header>
                <h5 class="mb-0 font-weight-bold text-primary text-left">1. Program Information</h5>
            </template>
            <div class="p-2">
                <BRow class="mb-4">
                    <BCol class="text-start">
                        <BFormGroup
                            label-cols-sm="4"
                            label-cols-lg="3"
                            content-cols-sm
                            content-cols-lg="7"
                            label="Program Name *"
                            label-for="name"
                        >
                            <BFormInput
                                v-model="formProgram.name"
                                type="text"
                                id="name"
                                placeholder="Enter Program Name"
                                :class="{
                                    'is-invalid': vProgram$.form.name.$dirty && vProgram$.form.name.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback :state="vProgram$.form.name.$dirty && vProgram$.form.name.$invalid">
                                {{ vProgram$.form.name.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-4">
                    <BCol class="text-start">
                        <BFormGroup
                            label-cols-sm="4"
                            label-cols-lg="3"
                            content-cols-sm
                            content-cols-lg="7"
                            label="Pax *"
                            label-for="pax"
                        >
                            <BFormInput
                                v-model="formProgram.pax"
                                type="number"
                                id="pax"
                                placeholder="Enter Pax"
                                :class="{
                                    'is-invalid': vProgram$.form.pax.$dirty && vProgram$.form.pax.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback :state="vProgram$.form.pax.$dirty && vProgram$.form.pax.$invalid">
                                {{ vProgram$.form.pax.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-4">
                    <BCol class="text-start">
                        <BFormGroup
                            label-cols-sm="4"
                            label-cols-lg="3"
                            content-cols-sm
                            content-cols-lg="7"
                            label="Route"
                            label-for="route"
                        >
                            <v-select
                                v-model="selectedRoute"
                                id="route"
                                label="name"
                                :options="routeList"
                                :searchable="true"
                                :clearable="true"
                                :loading="routeLoading"
                                @open="getRouteList"
                                placeholder="Select Route"
                            >
                                <template #option="{ from, to, description }">
                                    {{ from.name }} - {{ to.name }}
                                    {{ description?.trim() != null ? `(${description})` : "" }}
                                </template>
                                <template #selected-option="{ from, to, description }">
                                    {{ from.name }} - {{ to.name }}
                                    {{ description?.trim() != null ? `(${description})` : "" }}
                                </template>
                            </v-select>
                            <small class="text-muted">Optional (only if a route already exists)</small>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-4">
                    <BCol class="text-start">
                        <BFormGroup
                            label-cols-sm="4"
                            label-cols-lg="3"
                            content-cols-sm
                            content-cols-lg="7"
                            label="From *"
                            label-for="from_destination"
                        >
                            <v-select
                                id="from_destination"
                                v-model="formProgram.from_destination_uuid"
                                label="name"
                                :options="destinationList"
                                :reduce="(item) => item.uuid"
                                :searchable="true"
                                :clearable="true"
                                @option:selecting="setFromDestination"
                                placeholder="Select Start Destination"
                                :class="{
                                    'is-invalid':
                                        vProgram$.form.from_destination_uuid.$dirty &&
                                        vProgram$.form.from_destination_uuid.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="vProgram$.form.from_destination_uuid.$dirty && vProgram$.form.from_destination_uuid.$invalid"
                            >
                                {{ vProgram$.form.from_destination_uuid.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
                <BRow class="mb-4">
                    <BCol class="text-start">
                        <BFormGroup
                            label-cols-sm="4"
                            label-cols-lg="3"
                            content-cols-sm
                            content-cols-lg="7"
                            label="To *"
                            label-for="to_destination"
                        >
                            <v-select
                                id="to_destination"
                                v-model="formProgram.to_destination_uuid"
                                label="name"
                                :options="destinationList"
                                :reduce="(item) => item.uuid"
                                :searchable="true"
                                :clearable="true"
                                @option:selecting="setToDestination"
                                placeholder="Select End Destination"
                                :class="{
                                    'is-invalid':
                                        vProgram$.form.to_destination_uuid.$dirty &&
                                        vProgram$.form.to_destination_uuid.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback
                                :state="vProgram$.form.to_destination_uuid.$dirty && vProgram$.form.to_destination_uuid.$invalid"
                            >
                                {{ vProgram$.form.to_destination_uuid.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                </BRow>
            </div>
        </BCard>

        <!-- 2. Program Description -->
        <BCard class="mb-4 shadow-sm border-0">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 font-weight-bold text-primary">2. Program Description</h5>
                </div>
            </template>
            <div class="p-2">
                <BTabs content-class="mt-3">
                    <!-- Transportation Tab -->
                    <BTab>
                        <template #title>
                            <i class="fas fa-car me-2"></i> <span>Transportation</span>
                        </template>
                        <div class="d-flex justify-content-end mb-3">
                            <BButton variant="outline-primary" size="sm" @click="createModalTransportation">
                                <i class="fas fa-plus"></i> Add Transportation
                            </BButton>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-hover mb-0">
                                <thead class="bg-light small">
                                    <tr>
                                        <th class="text-center font-weight-bold">Vehicle</th>
                                        <th class="text-center font-weight-bold" width="100">Pax</th>
                                        <th class="text-right font-weight-bold" width="150">Price</th>
                                        <th class="text-right font-weight-bold" width="150">Subtotal</th>
                                        <th class="text-center font-weight-bold" width="100">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="small">
                                    <tr v-for="(item, index) in transportationItems" :key="'t-'+index">
                                        <td class="text-left font-weight-bold">{{ item.vehicle?.name }}</td>
                                        <td class="text-center">{{ item.pax }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.price) }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.sub_total) }}</td>
                                        <td class="text-center">
                                            <BButton variant="link" class="text-warning p-0 me-2" @click="editTransportation({item})">
                                                <i class="fas fa-edit"></i>
                                            </BButton>
                                            <BButton variant="link" class="text-danger p-0" @click="removeTransportation(item)">
                                                <i class="fas fa-trash"></i>
                                            </BButton>
                                        </td>
                                    </tr>
                                    <tr v-if="!transportationItems.length">
                                        <td colspan="5" class="text-center text-muted italic p-3">No transportation available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </BTab>

                    <!-- Accomodation Tab -->
                    <BTab>
                        <template #title>
                            <i class="fas fa-hotel me-2 text-primary"></i> <span class="text-primary">Accommodation</span>
                        </template>
                        <div class="d-flex justify-content-end mb-3">
                            <BButton variant="outline-primary" size="sm" @click="createModalAccomodation">
                                <i class="fas fa-plus"></i> Add Accommodation
                            </BButton>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-hover mb-0">
                                <thead class="bg-light small">
                                    <tr>
                                        <th class="text-left font-weight-bold">Hotel</th>
                                        <th class="text-center font-weight-bold">Pax</th>
                                        <th class="text-right font-weight-bold">Price</th>
                                        <th class="text-right font-weight-bold">Subtotal</th>
                                        <th class="text-center font-weight-bold">Extra Bed</th>
                                        <th class="text-right font-weight-bold">Extra Bed Price</th>
                                        <th class="text-right font-weight-bold">Total Price</th>
                                        <th class="text-center font-weight-bold" width="100">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="small">
                                    <tr v-for="(item, index) in accomodationItems" :key="'ac-'+index">
                                        <td class="text-left">
                                            <div class="font-weight-bold">{{ item.name }}</div>
                                            <div class="text-muted small">
                                                {{ item.destination?.name }}{{ item.room_type ? ' - ' + item.room_type : '' }}
                                            </div>
                                        </td>
                                        <td class="text-center">{{ item.pax }}</td>
                                        <td class="text-right">{{ formatRupiah(item.price) }}</td>
                                        <td class="text-right">{{ formatRupiah(item.sub_total) }}</td>
                                        <td class="text-center">
                                            <span 
                                                class="badge" 
                                                :class="item.extra_bed == 1 ? 'border border-success text-success' : 'border border-danger text-danger'"
                                                style="padding: 2px 10px; border-radius: 4px;"
                                            >
                                                {{ item.extra_bed == 1 ? 'Yes' : 'No' }}
                                            </span>
                                        </td>
                                        <td class="text-right">{{ formatRupiah(item.extra_bed_price) }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.total_price) }}</td>
                                        <td class="text-center">
                                            <BButton variant="link" class="text-warning p-0 me-2" @click="editAccomodation({item})">
                                                <i class="fas fa-edit"></i>
                                            </BButton>
                                            <BButton variant="link" class="text-danger p-0" @click="removeAccomodation(item)">
                                                <i class="fas fa-trash"></i>
                                            </BButton>
                                        </td>
                                    </tr>
                                    <tr v-if="!accomodationItems.length">
                                        <td colspan="8" class="text-center text-muted italic p-3">No accommodation available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </BTab>

                    <!-- Activity Tab -->
                    <BTab>
                        <template #title>
                            <i class="fas fa-walking me-2 text-primary"></i> <span class="text-primary">Activities</span>
                        </template>
                        <div class="d-flex justify-content-end mb-3">
                            <BButton variant="outline-primary" size="sm" @click="createModalActivity">
                                <i class="fas fa-plus"></i> Add Activity
                            </BButton>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-hover mb-0">
                                <thead class="bg-light small">
                                    <tr>
                                        <th class="text-left font-weight-bold">Activity Name</th>
                                        <th class="text-center font-weight-bold" width="100">Pax</th>
                                        <th class="text-right font-weight-bold" width="150">Price</th>
                                        <th class="text-right font-weight-bold" width="150">Subtotal</th>
                                        <th class="text-center font-weight-bold" width="100">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="small">
                                    <tr v-for="(item, index) in activityItems" :key="'act-'+index">
                                        <td class="text-left font-weight-bold">{{ item.name }}</td>
                                        <td class="text-center">{{ item.pax }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.price) }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.sub_total) }}</td>
                                        <td class="text-center">
                                            <BButton variant="link" class="text-warning p-0 me-2" @click="editActivity({item})">
                                                <i class="fas fa-edit"></i>
                                            </BButton>
                                            <BButton variant="link" class="text-danger p-0" @click="removeActivity(item)">
                                                <i class="fas fa-trash"></i>
                                            </BButton>
                                        </td>
                                    </tr>
                                    <tr v-if="!activityItems.length">
                                        <td colspan="5" class="text-center text-muted italic p-3">No activity available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </BTab>

                    <!-- Meals Tab -->
                    <BTab>
                        <template #title>
                            <i class="fas fa-utensils me-2 text-primary"></i> <span class="text-primary">Meals</span>
                        </template>
                        <div class="d-flex justify-content-end mb-3">
                            <BButton variant="outline-primary" size="sm" @click="createModalMeal">
                                <i class="fas fa-plus"></i> Add Meal
                            </BButton>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered table-hover mb-0">
                                <thead class="bg-light small">
                                    <tr>
                                        <th class="text-left font-weight-bold">Meal Name</th>
                                        <th class="text-center font-weight-bold" width="100">Pax</th>
                                        <th class="text-right font-weight-bold" width="150">Price</th>
                                        <th class="text-right font-weight-bold" width="150">Subtotal</th>
                                        <th class="text-center font-weight-bold" width="100">Action</th>
                                    </tr>
                                </thead>
                                <tbody class="small">
                                    <tr v-for="(item, index) in mealItems" :key="'m-'+index">
                                        <td class="text-left font-weight-bold">{{ item.name }}</td>
                                        <td class="text-center">{{ item.pax }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.price) }}</td>
                                        <td class="text-right font-weight-bold">{{ formatRupiah(item.sub_total) }}</td>
                                        <td class="text-center">
                                            <BButton variant="link" class="text-warning p-0 me-2" @click="editMeal({item})">
                                                <i class="fas fa-edit"></i>
                                            </BButton>
                                            <BButton variant="link" class="text-danger p-0" @click="removeMeal(item)">
                                                <i class="fas fa-trash"></i>
                                            </BButton>
                                        </td>
                                    </tr>
                                    <tr v-if="!mealItems.length">
                                        <td colspan="5" class="text-center text-muted italic p-3">No meal available</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </BTab>
                </BTabs>
            </div>
        </BCard>

        <!-- 3. Pricing -->
        <BCard class="mb-4 shadow-sm border-0">
            <template #header>
                <h5 class="mb-0 font-weight-bold text-primary text-left">3. Pricing</h5>
            </template>
            <div class="p-2">
                <BRow class="mb-4">
                    <BCol md="7" class="text-left">
                        <BFormGroup label="Inclusion" label-for="inclusion" class="mb-3">
                            <BFormTextarea
                                v-model="formProgram.inclusion"
                                id="inclusion"
                                placeholder="Enter Inclusion"
                                :rows="7"
                                :class="{
                                    'is-invalid': vProgram$.form.inclusion.$dirty && vProgram$.form.inclusion.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback :state="vProgram$.form.inclusion.$dirty && vProgram$.form.inclusion.$invalid">
                                {{ vProgram$.form.inclusion.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                        <BFormGroup label="Exclusion" label-for="exclusion">
                            <BFormTextarea
                                v-model="formProgram.exclusion"
                                id="exclusion"
                                placeholder="Enter Exclusion"
                                :rows="7"
                                :class="{
                                    'is-invalid': vProgram$.form.exclusion.$dirty && vProgram$.form.exclusion.$invalid,
                                }"
                            />
                            <BFormInvalidFeedback :state="vProgram$.form.exclusion.$dirty && vProgram$.form.exclusion.$invalid">
                                {{ vProgram$.form.exclusion.$errors[0]?.$message }}
                            </BFormInvalidFeedback>
                        </BFormGroup>
                    </BCol>
                    <BCol md="5">
                        <div class="card bg-light p-4 shadow-none">
                            <table class="table table-sm table-borderless mb-0">
                                <tr class="h5">
                                    <td class="text-left pt-2 font-weight-bold text-primary">Total Price ({{ formProgram?.pax }} Pax)</td>
                                    <td class="text-right pt-2 text-primary font-weight-bold">
                                        {{ formProgram?.sub_total ? formatRupiah(formProgram.sub_total) : "Rp 0" }}
                                    </td>
                                </tr>
                                <tr class="h6">
                                    <td class="text-left font-weight-bold text-muted">Price Per Person</td>
                                    <td class="text-right text-muted font-weight-bold">
                                        {{ formProgram?.price ? formatRupiah(formProgram.price) : "Rp 0" }}
                                    </td>
                                </tr>
                            </table>
                            <p class="small text-muted italic mt-3 text-left">
                                <i class="fas fa-info-circle"></i> This price is automatically calculated from all items
                                added above.
                            </p>
                        </div>
                    </BCol>
                </BRow>
            </div>
            <template #footer>
                <div class="d-flex justify-content-end">
                    <BButton @click="validateAndPreview" variant="primary" class="me-2 px-4">
                        <i class="fas fa-save me-1"></i> Save Program
                    </BButton>
                    <BButton type="button" @click="() => router.back()" variant="danger" class="px-4">
                        <i class="fas fa-times me-1"></i> Cancel
                    </BButton>
                </div>
            </template>
        </BCard>
    </BForm>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import { ref, onMounted, reactive, watch } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minValue, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import TransportarionForm from "./TransportationForm.vue";
// import { useToast } from "vue-toastification";
// import { formatRupiah } from "@/utils/format";
import {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BModal,
    BRow,
    BTab,
    BTabs,
} from "bootstrap-vue-next";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { formatRupiah } from "@/utils/format";
import AccommodationForm from "./AccommodationForm.vue";
import ActivityForm from "./ActivityForm.vue";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import MealForm from "./MealForm.vue";

const auth = useAuthStore();
const $loading = useLoading();

// const swal = inject("$swal");
const route = useRoute();
const router = useRouter();
const toast = useToast();

// (programDays logic removed)

/*
 * **********************************************************
 * Transportation
 * **********************************************************
 */
const selectedTransportation = ref({});
const modalTransportation = ref(false);

const createModalTransportation = () => {
    selectedTransportation.value = {};
    modalTransportation.value = true;
};

const updateModalTransportation = (newVal) => {
    modalTransportation.value = newVal;
};

const addOrUpdateTransportation = (form) => {
    if (form.index !== undefined) {
        // Update data di posisi index
        form.price_format = formatRupiah(form.price);
        transportationItems.value[form.index] = {
            ...transportationItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        form.price_format = formatRupiah(form.price);
        transportationItems.value.push({ ...form });
    }

    combineInclusionExclusion();
    sumTotalPrice();
};

const editTransportation = (row) => {
    const item = row.item;
    const globalIndex = transportationItems.value.indexOf(item);
    selectedTransportation.value = {
        index: globalIndex,
        ...item,
    };
    modalTransportation.value = true;
};

const removeTransportation = (item) => {
    const index = transportationItems.value.indexOf(item);
    if (index > -1) {
        transportationItems.value.splice(index, 1);
        combineInclusionExclusion();
        sumTotalPrice();
    }
};

let transportationItems = ref([]);


/*
 * **********************************************************
 * Accomodation
 * **********************************************************
 */

const selectedAccomodation = ref({});
const modalAccomodation = ref(false);

const createModalAccomodation = () => {
    selectedAccomodation.value = {};
    modalAccomodation.value = true;
};

const updateModalAccomodation = (newVal) => {
    modalAccomodation.value = newVal;
};

const addOrUpdateAccomodation = (form) => {
    form.price_format = formatRupiah(form.price);
    form.destination_format =
        form.destination.name + " (" + form.destination.code + ")";
    if (form.index !== undefined) {
        // Update data di posisi index
        accomodationItems.value[form.index] = {
            ...accomodationItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        accomodationItems.value.push({ ...form });
    }
    combineInclusionExclusion();
    sumTotalPrice();
};

const editAccomodation = (row) => {
    const item = row.item;
    const globalIndex = accomodationItems.value.indexOf(item);
    selectedAccomodation.value = {
        index: globalIndex,
        ...item,
    };
    modalAccomodation.value = true;
};

const removeAccomodation = (item) => {
    const index = accomodationItems.value.indexOf(item);
    if (index > -1) {
        accomodationItems.value.splice(index, 1);
        combineInclusionExclusion();
        sumTotalPrice();
    }
};

let accomodationItems = ref([]);



/*
 *
 ************************************************
 *
 */

/*
 * **********************************************************
 * Activity
 * **********************************************************
 */

const selectedActivity = ref({});
const modalActivity = ref(false);

const createModalActivity = () => {
    selectedActivity.value = {};
    modalActivity.value = true;
};

const updateModalActivity = (newVal) => {
    modalActivity.value = newVal;
};

const addOrUpdateActivity = (form) => {
    form.price_format = formatRupiah(form.price);
    form.destination_format =
        form.destination.name + " (" + form.destination.code + ")";
    if (form.index !== undefined) {
        // Update data di posisi index
        activityItems.value[form.index] = {
            ...activityItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        activityItems.value.push({ ...form });
    }

    combineInclusionExclusion();
    sumTotalPrice();
};

const editActivity = (row) => {
    const item = row.item;
    const globalIndex = activityItems.value.indexOf(item);
    selectedActivity.value = {
        index: globalIndex,
        ...item,
    };
    modalActivity.value = true;
};

const removeActivity = (item) => {
    const index = activityItems.value.indexOf(item);
    if (index > -1) {
        activityItems.value.splice(index, 1);
        combineInclusionExclusion();
        sumTotalPrice();
    }
};

let activityItems = ref([]);


/*
 * **********************************************************
 * Meals
 * **********************************************************
 */

const selectedMeal = ref({});
const modalMeal = ref(false);

const createModalMeal = () => {
    selectedMeal.value = {};
    modalMeal.value = true;
};

const updateModalMeal = (newVal) => {
    modalMeal.value = newVal;
};

const addOrUpdateMeal = (form) => {
    form.price_format = formatRupiah(form.price);

    if (form.index !== undefined) {
        // Update data di posisi index
        mealItems.value[form.index] = {
            ...mealItems.value[form.index],
            ...form,
        };
    } else {
        // Tambah data baru
        mealItems.value.push({ ...form });
    }
    sumTotalPrice();
};

const editMeal = (row) => {
    const item = row.item;
    const globalIndex = mealItems.value.indexOf(item);
    selectedMeal.value = {
        index: globalIndex,
        ...item,
    };
    modalMeal.value = true;
};

const removeMeal = (item) => {
    const index = mealItems.value.indexOf(item);
    if (index > -1) {
        mealItems.value.splice(index, 1);
        sumTotalPrice();
    }
};

let mealItems = ref([]);


/*
 *
 ************************************************
 *
 */

//Meals Name Option
// const mealsNameOptions = [
//     {
//         value: "Lunch",
//         text: "Lunch",
//     },
//     {
//         value: "Dinner",
//         text: "Dinner",
//     },
// ];

// const combineInclusionExclusion = () => {
//     const allInclusions = [
//         ...accomodationItems.value.map((item) => item.inclusion || ""),
//         ...transportationItems.value.map((item) => item.inclusion || ""),
//         ...activityItems.value.map((item) => item.inclusion || ""),
//     ].filter(Boolean); // hapus kosong

//     // Gabungkan semua exclusion
//     const allExclusions = [
//         ...accomodationItems.value.map((item) => item.exclusion || ""),
//         ...transportationItems.value.map((item) => item.exclusion || ""),
//         ...activityItems.value.map((item) => item.exclusion || ""),
//     ].filter(Boolean);

//     // Simpan ke form (dipisah baris baru)
//     formProgram.inclusion = allInclusions.join("\n");
//     formProgram.exclusion = allExclusions.join("\n");
// };

const combineInclusionExclusion = () => {
    const allInclusions = [];
    const allExclusions = [];

    const allItems = [
        ...accomodationItems.value,
        ...transportationItems.value,
        ...activityItems.value,
    ];

    allItems.forEach((item) => {
        // === Handle Inclusion ===
        if (item?.inclusion) {
            // pisah berdasarkan newline, bersihkan tiap baris
            const inclusions = item.inclusion
                .split("\n")
                .map((v) => v.replace(/\s+/g, " ").trim()) // hapus spasi/tab ganda
                .filter(Boolean);

            inclusions.forEach((val) => {
                // cek duplikat tanpa peduli huruf besar
                if (!allInclusions.some((v) => v.toLowerCase() === val.toLowerCase())) {
                    allInclusions.push(val);
                }
            });
        }

        // === Handle Exclusion ===
        if (item?.exclusion) {
            const exclusions = item.exclusion
                .split("\n")
                .map((v) => v.replace(/\s+/g, " ").trim())
                .filter(Boolean);

            exclusions.forEach((val) => {
                if (!allExclusions.some((v) => v.toLowerCase() === val.toLowerCase())) {
                    allExclusions.push(val);
                }
            });
        }
    });

    // Simpan ke form
    formProgram.inclusion = allInclusions.join("\n");
    formProgram.exclusion = allExclusions.join("\n");

};

const sumTotalPrice = () => {
    const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };

    const totalTransportation = transportationItems.value.reduce(
        (sum, item) => sum + safeNumber(item.sub_total),
        0
    );
    const totalAccomodation = accomodationItems.value.reduce(
        (sum, item) => sum + safeNumber(item.total_price),
        0
    );
    const totalActivity = activityItems.value.reduce(
        (sum, item) => sum + safeNumber(item.sub_total),
        0
    );
    const totalMeal = mealItems.value.reduce(
        (sum, item) => sum + safeNumber(item.sub_total),
        0
    );

    const grandTotal =
        safeNumber(totalTransportation) +
        safeNumber(totalAccomodation) +
        safeNumber(totalActivity) +
        safeNumber(totalMeal);

    formProgram.sub_total = grandTotal;
    
    // Calculate per-person price
    const programPax = safeNumber(formProgram.pax) || 1;
    formProgram.price = grandTotal / programPax;
};

// Program

const formProgramData = {
    uuid: "",
    name: "",
    pax: 1,
    from_destination_uuid: "",
    from_destination: "",
    to_destination_uuid: "",
    to_destination: "",
    transportation: [],
    accommodation: [],
    activity: [],
    meals: [],
    price: "",
    sub_total: "",
    inclusion: "",
    exclusion: "",
};

const formProgram = reactive({ ...formProgramData });

watch(() => formProgram.pax, () => {
    sumTotalPrice();
});

const rules = {
    form: {
        name: {
            required: helpers.withMessage("Name is required", required),
            minLength: helpers.withMessage(
                "Name must be at least 3",
                minLength(3)
            ),
        },
        pax: {
            required: helpers.withMessage("Pax is required", required),
            minValue: helpers.withMessage(
                "Pax must be at least 1",
                minValue(1)
            ),
        },
        from_destination_uuid: {
            required: helpers.withMessage(
                "Start destination is required",
                required
            ),
        },
        to_destination_uuid: {
            required: helpers.withMessage(
                "End destination is required",
                required
            ),
        },
        inclusion: {},
        exclusion: {},
    },
};

const vProgram$ = useVuelidate(rules, { form: formProgram });

const modalPreview = ref(false);

const validateAndPreview = () => {
    vProgram$.value.$touch();
    if (!vProgram$.value.$invalid) {
        modalPreview.value = true;
    } else {
        const firstErrorField = Object.keys(rules.form).find(
            (key) => vProgram$.value.form[key]?.$errors?.length
        );
        if (firstErrorField) {
            const errorMsg =
                vProgram$.value.form[firstErrorField].$errors[0].$message;
            toast.warning(errorMsg);
        }
    }
};

const handleAction = () => {
    modalPreview.value = false;
    route.params.uuid != undefined ? update() : create();
};

const create = async () => {
    toast.clear();
    vProgram$.value.$touch();
    if (!vProgram$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/program/add`,
                {
                    name: formProgram.name,
                    pax: formProgram.pax,
                    from_destination_uuid: formProgram.from_destination_uuid,
                    to_destination_uuid: formProgram.to_destination_uuid,
                    transportation: transportationItems.value,
                    accommodation: accomodationItems.value,
                    activity: activityItems.value,
                    meals: mealItems.value,
                    inclusion: formProgram.inclusion,
                    exclusion: formProgram.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                router.push("/programs");
            }
        } finally {
            loader.hide();
        }
    } else {
        const firstErrorField = Object.keys(rules.form).find(
            (key) => vProgram$.value.form[key]?.$errors?.length
        );
        if (firstErrorField) {
            const errorMsg =
                vProgram$.value.form[firstErrorField].$errors[0].$message;
            toast.warning(errorMsg);
        }
    }
};

const update = async () => {
    toast.clear();
    vProgram$.value.$touch();
    if (!vProgram$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/program/edit/${route.params.uuid}`,
                {
                    name: formProgram.name,
                    pax: formProgram.pax,
                    from_destination_uuid: formProgram.from_destination_uuid,
                    to_destination_uuid: formProgram.to_destination_uuid,
                    transportation: transportationItems.value,
                    accommodation: accomodationItems.value,
                    activity: activityItems.value,
                    meals: mealItems.value,
                    inclusion: formProgram.inclusion,
                    exclusion: formProgram.exclusion,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                router.push("/programs");
            }
        } finally {
            loader.hide();
        }
    } else {
        const firstErrorField = Object.keys(rules.form).find(
            (key) => vProgram$.value.form[key]?.$errors?.length
        );

        if (firstErrorField) {
            const errorMsg =
                vProgram$.value.form[firstErrorField].$errors[0].$message;
            toast.error(errorMsg);
        }
    }
};

const selectedRoute = ref(null);
let routeList = ref([]);
let routeLoading = ref(false);

const getRouteList = async () => {
    routeLoading.value = true;

    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/route`,
            {
                params: {
                    pax: formProgram.pax,
                },
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            routeList.value = res.data.map((r) => ({
                ...r,
                name: `${r.from.name} - ${r.to.name}`,
            }));

            if (routeList.value.length > 0) {
                selectedRoute.value = routeList.value[0];
            } else {
                selectedRoute.value = [];
            }
        }
    } finally {
        routeLoading.value = false;
    }
};

let destinationList = ref([]);

const getAllDestination = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

const getProgram = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/program/detail/${route.params.uuid}`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            const data = res.data;

            formProgram.name = data.name;
            formProgram.pax = data.pax;
            formProgram.from_destination = data.from_destination;
            formProgram.to_destination = data.to_destination;
            formProgram.from_destination_uuid = data.from_destination_uuid;
            formProgram.to_destination_uuid = data.to_destination_uuid;
            formProgram.inclusion = data.inclusion;
            formProgram.exclusion = data.exclusion;
            if (data.transportation && Array.isArray(data.transportation)) {
                transportationItems.value = data.transportation.map((item) => ({
                    ...item,
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.accommodation && Array.isArray(data.accommodation)) {
                accomodationItems.value = data.accommodation.map((item) => ({
                    ...item,
                    destination_format:
                        item.destination.name +
                        " (" +
                        item.destination.code +
                        ")",
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.activity && Array.isArray(data.activity)) {
                activityItems.value = data.activity.map((item) => ({
                    ...item,
                    destination_format:
                        item.destination.name +
                        " (" +
                        item.destination.code +
                        ")",
                    price_format: formatRupiah(item.price),
                }));
            }

            if (data.meals && Array.isArray(data.meals)) {
                mealItems.value = data.meals.map((item) => ({
                    ...item,
                    price_format: formatRupiah(item.price),
                }));
            }

            sumTotalPrice();
        }
    } finally {
        loader.hide();
    }
};

const setFromDestination = (val) => {
    formProgram.from_destination = val;
};

const setToDestination = (val) => {
    formProgram.to_destination = val;
};

watch(selectedRoute, (val) => {
    if (val && val.from && val.to) {
        formProgram.from_destination_uuid = val.from.uuid;
        formProgram.from_destination = val.from;
        formProgram.to_destination_uuid = val.to.uuid;
        formProgram.to_destination = val.to;
    } else {
        formProgram.from_destination_uuid = null;
        formProgram.to_destination_uuid = null;
        formProgram.from_destination = null;
        formProgram.to_destination = null;
    }
});

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAllDestination();
        if (route.params.uuid) {
            await getProgram();
        }
    } finally {
        loader.hide();
    }
});
</script>
